import { useContext } from 'react';
import UtilContext from '../contexts/UtilContext';

const useUtil = () => useContext(UtilContext);

export default useUtil;
